<template>
    <header>
      <div id="elliptischeFlagge" title="rumänische Flagge">
      </div>
      <div id="flagge" title="rumänische Flagge">
      </div>
      <TopNavigation />
    </header>
</template>

<script>
// @ is an alias to /src
import TopNavigation from '@/components/TopNavigation.vue';

export default {
  name: 'headSection',
  components: {
    TopNavigation
  }
}
</script>
